<template>
  <div class="napaLists" style="margin-top: 24px;">
    <div
      class="napaItem"
      v-for="(item, index) in applicationReceivedList"
      :key="index"
      @click="() => handleClickItem(item)"
      style="display: flex; align-items: center; "
      :style="{ 'background-color': getBackgroundCard(item.status) }"
    >
      <figure class="napaItemImage">
        <img :src="item.img" alt="" />
      </figure>
      <div class="napaItemText">
        <div>
          <h6 class="napaItemTitle">
            {{ item.title }}
          </h6>
          <h3
            class="napaItemDesc"
            style="display: flex; align-items: center; flex-wrap: wrap;"
          >
            {{ item.desc }}
            <span
              v-if="item.type == 'research'"
              :style="{
                'background-color': item.status == 4 ? '#D3ACAC' : '#AACFD1',
              }"
              class="chip-user"
              >연구자</span
            >
          </h3>
          <h6 class="napaItemTime">2023.01.23 PM 11:21</h6>
        </div>
        <MainBadge
          :title="getBtnLabel(item.status)"
          :variant="getBadgeVariant(item.status)"
        />
      </div>

      <div>
        <MainButton
          size="large"
          :btnText="getBtnText(item.status)"
          :color="getBtnColor(item.status)"
        />
        <button
          class="btn-outlined"
          @click="(e) => handleClickItemButtonDelete(e, item)"
        >
          삭제하기
        </button>
      </div>
    </div>
  </div>
</template>
<!-- 
자문 완료 
승인 대기 
자문 대기
승인 완료
승인 거절

Advisory completed // green 0
waiting for approval // blue 1
waiting for advice // green 2
Approved // green 3
decline approval // red 4
-->

<script>
import MainBadge from "@/components/badge/MainBadge.vue";
import MainButton from "@/components/button/MainButton.vue";

export default {
  name: "ApplicationReceivedItem",
  components: { MainButton, MainBadge },
  props: {
    items: Array,
    handleClickItem: Function,
    handleClickItemButtonDelete: Function,
  },
  data() {
    return {
      backgroundCard: "",
      applicationReceivedList: [
        {
          title: "보낸 기업",
          desc: "(주)행복을 만드는 사람들",
          date: "2023.01.23 PM 11:21",
          status: 0,
          img: "/images/manager/matching/matching1.png",
          type: "user",
        },
        {
          title: "(주)행복을 만드는 사람들",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 1,
          type: "user",
          img: "/images/manager/matching/matching1.png",
        },
        {
          title: "보낸 기업",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 2,
          type: "research",
          img: "/images/manager/matching/matching3.png",
        },
        {
          title: "(주)행복을 만드는 사람들",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 3,
          type: "user",
          img: "/images/manager/matching/matching1.png",
        },
        {
          title: "보낸 기업",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 4,
          type: "research",
          img: "/images/manager/matching/matching3.png",
        },
        {
          title: "보낸 기업",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 5,
          type: "research",
          img: "/images/manager/matching/matching3.png",
        },
        {
          title: "보낸 기업",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 6,
          type: "research",
          img: "/images/manager/matching/matching3.png",
        },
      ],
    };
  },

  computed: {
    getBackgroundCard() {
      return function(status) {
        switch (status) {
          case 0:
            return "#FAFEFF";
          case 1:
            return "#FDFFFA";
          case 2:
            return "#FFFBFB";
          case 3:
            return "#FAFEFF";
          case 4:
            return "#FFFBFB";
          default:
            return "#FFFBFB";
        }
      };
    },

    getBtnColor() {
      return function(status) {
        switch (status) {
          case 0:
            return "primary";
          case 1:
            return "green";
          case 2:
            return "green";
          case 3:
            return "primary";
          case 4:
            return "primary";
          default:
            return "primary";
        }
      };
    },
    getBtnText() {
      return function(status) {
        switch (status) {
          case 0:
            return "신청서 보기";
          case 1:
            return "자문서 보기";
          case 2:
            return "자문서 보기";
          case 3:
            return "신청서 보기";
          case 4:
            return "신청서 보기";
          default:
            return "신청서 보기";
        }
      };
    },

    getBadgeVariant() {
      return function(status) {
        switch (status) {
          case 0:
            return "green";
          case 1:
            return "blue";
          case 2:
            return "green";
          case 3:
            return "blue";
          case 4:
            return "red";
          default:
            return "red";
        }
      };
    },

    getBtnLabel() {
      return function(status) {
        switch (status) {
          case 0:
            return "승인 대기";
          case 1:
            return "승인 완료";
          case 2:
            return "승인 거절";
          default:
            return "승인 대기";
        }
      };
    },
  },
};
</script>
<style lang="scss" scoped>
// Section 2

.btn-outlined {
  height: 48px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 2.1rem;
  margin-top: 16px;
  cursor: pointer;
}

.chip-user {
  font-size: 1.4rem;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  margin-left: 4px;
}
</style>
